import React from 'react'

const Error = () => {
  return (
    <div><p></p></div>
  )
}

export default Error